import React from 'react';
import { connect } from 'utils/enhancedReduxConnect';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { checkAccess } from 'containers';
import { StoreState } from 'store';
import { Role } from '../../types/api/user/dictionaries';

interface StateProps {
  me: StoreState['me'];
}

interface OwnProps {
  forRole: Role[];
}

type Props = OwnProps & StateProps & RouteProps;

function ProtectedRoute(props: Props) {
  const { children, component, me: { user }, render, forRole, ...rest } = props;

  return (
    <Route {...rest} render={(...props) => {
      if (user == null) {
        // TODO: redirect logic
        window.location.replace("https://dialog.x5.ru/targeting");
      }

      if (!checkAccess(forRole, user?.role)) {
        return (
          <Redirect to="/forbidden" />
        );
      }

      return (
        <Route {...props} children={children} component={component} render={render} />
      );
    }} />
  );
}

export default connect<StateProps, {}, {}, StoreState>(({ me }) => ({ me }))(ProtectedRoute);
